import { useCallback } from 'react';

import Button from '@mui/material/Button';

import { useRouter } from 'src/routes/hooks';

import { logger } from 'src/utils/logger';

import { toast } from 'src/components/snackbar';

import { useAuthContext } from 'src/auth/hooks';
import { signOutCurrent as signOut } from 'src/auth/context/jwt/action';

// ----------------------------------------------------------------------


export function SignOutButton({ onClose, ...other }) {
  const router = useRouter();

  const { checkUserSession } = useAuthContext();

  const handleLogout = useCallback(async () => {
    try {
      await signOut();
      await checkUserSession?.();

      onClose?.();
      router.home();
      router.refresh();
    } catch (error) {
      logger.error('Error during logout from SignOutButton:', error);
      toast.error('Unable to logout!');
    }
  }, [checkUserSession, onClose, router]);

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="warning"
      onClick={handleLogout}
      {...other}
    >
      Logout
    </Button>
  );
}
